import { CommonModule } from '@angular/common';
import { Component, Inject, Optional, Output, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserPreferences } from '../../../models/user-preferences.model';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../../../../../environments/environment';
import { Input, OnInit } from '@angular/core';
@Component({
  selector: `app-download-app-dialog`,
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: `./download-app-dialog.component.html`,
  styleUrl: `./download-app-dialog.component.scss`,
})
export class DownloadAppDialogComponent implements OnInit {
  @Input() userPreferences: UserPreferences;

  @Output() closeDialog: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    @Optional() private readonly dialogRef: MatDialogRef<DownloadAppDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    @Optional()
    private readonly data: {
      userPreferences: UserPreferences;
    },
  ) {}

  ngOnInit(): void {
    if (this.data?.userPreferences) {
      this.userPreferences = this.data.userPreferences;
    }
  }

  goToAppStore(): void {
    window.open(environment.mobile.ios, `_blank`);
  }

  goToPlayStore(): void {
    window.open(environment.mobile.android, `_blank`);
  }

  close(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    } else {
      this.closeDialog.emit();
    }
  }
}
